import React, { useRef, useState } from 'react'
import PropTypes from 'prop-types'
// import { Input } from 'antd'
import './../../ui.style.scss'
import Tooltip from './../../dataDisplay/ToolTip'
import InformationIcon from '../../general/icons/InformationIcon'
import { cloneDeep, isEmpty, isEqual, set } from 'lodash'
import { getJsonEditorContent } from 'components/ui/dataDisplay/utils'
import JsonEditor from 'components/ui/dataDisplay/JsonEditor'
import { JASON_EDITOR_OPTIONS_TO_REMOVE, JASON_EDITOR_USED_FOR_TYPES, JSON_EDITOR_HEADER_OPTIONS_TO_REMOVE, JSON_EDITOR_INDENTATION } from 'constants/general-constants'
import AddImageModal from 'components/ui/dataEntry/other/AddImageModal'
import { Icon, message, Modal } from 'antd'
import PopoverConfirm from 'components/ui/feedback/PopoverConfirm'

// const { TextArea } = Input

// const onChange = (handleChange, event) => {
//   const value = event.target.value
//   if (!value.startsWith(' ')) {
//     handleChange(event)
//   }
// }

const getFormDirtyValue = (isConfigObjectSaveDisable, useFor, isEnable) => {
  if (useFor === JASON_EDITOR_USED_FOR_TYPES.JSON_EDITOR_FOR_PAGES || useFor === JASON_EDITOR_USED_FOR_TYPES.JSON_EDITOR_FOR_LIST_CONFIG_TYPE) {
    return !isConfigObjectSaveDisable
  } else if (useFor === JASON_EDITOR_USED_FOR_TYPES.JSON_EDITOR_FOR_SETTING_WIDGET) {
    return isEnable
  }
}
const DEFAULT_MODE = 'tree'

const TextAreaInputApp = ({
  handleChange,
  value,
  jsonEditorValue,
  placeholder,
  title,
  inputName,
  isEditable,
  isLimited,
  limit,
  onFocus,
  isRequired,
  jsonInvalidEntries,
  currentId,
  isError,
  tooltipText,
  project,
  showContentInModal = true,
  useFor,
  isConfigSingleInstanceEdited,
  isConfigObjectSaveDisable,
  isEnable,
  ...props
}) => {
  const isFormDirty = useRef(getFormDirtyValue(isConfigObjectSaveDisable, useFor, isEnable))

  const jsonEditorInitialValues = useRef({
    isInitialJsonEditorChange: true,
    isInitialJsonEditorValue: null
  })

  let index = (jsonInvalidEntries || []).indexOf(currentId)
  let jsonError = isError
  let jsonErrorMessage = false
  if (index !== -1) {
    jsonError = true
    jsonErrorMessage = true
  }
  const [isImageModalOpen, setIsImageModalOpen] = useState(false)
  const [imagePathDetails, setImagePathDetails] = useState(null)
  const [jsonEditorsOpen, setJsonEditorsOpen] = useState({})
  const [jsonEditorModes, setJsonEditorModes] = useState({})

  const handleOpenImageModal = (flag, context) => {
    if (flag) {
      setIsImageModalOpen(true)
      setImagePathDetails(context.selection)
    } else {
      setIsImageModalOpen(false)
      setImagePathDetails(null)
    }
  }

  const handleContextMenuOptions = ({ items, context, config, selectedMeta, readOnly }) => {
    let contextMenuItemsNeeded = cloneDeep(items)
    const isValueContextType = context?.selection?.type === 'value'
    // if context menu opened on value type show image option
    // if (isValueContextType) {
    const isTableView = contextMenuItemsNeeded.length === 2
    const isTreeView = !isTableView
    let details = contextMenuItemsNeeded
    const imageOption = {
      type: 'button',
      onClick: () => handleOpenImageModal(true, context, config, selectedMeta),
      // icon: <Plus/>,
      text: '+ Image',
      title: 'Add image',
      disabled: readOnly || !isValueContextType
    }
    if (isTreeView) {
      details = contextMenuItemsNeeded.map((item, index) => {
        const itemWithCUtCopyEdit = 2
        if (index === itemWithCUtCopyEdit) {
          return {
            type: 'row',
            items: [imageOption]
          }
        } else {
          if (item.type === 'row') {
            return {
              ...item,
              items: item.items.map(rowItem => {
                if (rowItem.type === 'column') {
                  return {
                    ...rowItem,
                    items: rowItem.items.filter(columnItem => {
                      if (JASON_EDITOR_OPTIONS_TO_REMOVE.includes(columnItem.text)) {
                        return false
                      }
                      return true
                    })
                  }
                } else {
                  return rowItem
                }
              })
            }
          } else {
            return item
          }
        }
      })
    }
    if (isTableView) {
      details = contextMenuItemsNeeded.map((item, index) => {
        if (item.type === 'row') {
          return {
            ...item,
            items: item.items.map(rowItem => {
              if (rowItem.type === 'column') {
                let hasTableRow = false
                const filteredColumns = rowItem.items.filter(columnItem => {
                  if (columnItem.text === 'Table row:') {
                    hasTableRow = true
                  }
                  if (JASON_EDITOR_OPTIONS_TO_REMOVE.includes(columnItem?.main?.text) || JASON_EDITOR_OPTIONS_TO_REMOVE.includes(columnItem.text)) {
                    return false
                  }
                  return true
                })
                if (hasTableRow) {
                  filteredColumns.push(imageOption)
                }
                return {
                  ...rowItem,
                  items: filteredColumns
                }
              } else {
                return rowItem
              }
            })
          }
        } else {
          return item
        }
      })
    }
    return details
    // }

    // return contextMenuItemsNeeded
  }

  const handleJsonEditorOpenClose = (flag, id) => {
    if (flag) {
      // open modal
      setJsonEditorsOpen(prevState => {
        return {
          ...prevState.jsonEditorsOpen,
          [id]: true
        }
      })
    } else {
      // clone modal
      setJsonEditorsOpen(prevState => {
        return {
          ...prevState.jsonEditorsOpen,
          [id]: false
        }
      })
    }
  }
  const isJsonEditorModalOpen = jsonEditorsOpen?.[currentId] || false
  const handleJsonEditorModes = (mode, id) => {
    setJsonEditorModes(prevState => {
      return {
        ...prevState,
        [id]: mode
      }
    })
  }
  const mode = jsonEditorModes?.[currentId] || DEFAULT_MODE
  const jsonEditorValueDetails = jsonEditorValue || getJsonEditorContent(value)
  const getJsonEditorComponent = (readOnly, mode) => {
    return (
      <JsonEditor
        content={jsonEditorValueDetails}
        onChange={content => {
          handleChange(content)
        }}
        headerOptionsToRemove={JSON_EDITOR_HEADER_OPTIONS_TO_REMOVE}
        onRenderContextMenu={(items, context) => {
          return handleContextMenuOptions({ items, context, readOnly })
        }}
        readOnly={readOnly}
        onChangeMode={(mode) => handleJsonEditorModes(mode, currentId)}
        mode={mode}
      />
    )
  }

  const setDefaultMode = (jsonEditorValue, currentId, DEFAULT_MODE) => {
    if (isEmpty(jsonEditorValue?.text || jsonEditorValue?.json)) {
      handleJsonEditorModes('text', currentId)
    } else {
      handleJsonEditorModes(DEFAULT_MODE, currentId)
    }
  }

  const copyOnClick = (data, type) => {
    const value = data?.text || ''
    navigator.clipboard.writeText(value, type)
    message.success(`${type} Copied Successfully`)
  }
  return (
    <div className='json-editor-wrapper'>
      <div className={`input-field-editor text-area ${jsonError ? 'error' : ''}`}>
        <div>
          <label>{title}</label>
          {isRequired ? <span className='mandatory'>*</span> : ''}{' '}
          {tooltipText ? (
            <span id='info-icon'>
              <Tooltip
                placement='rightTop'
                childComponent={
                  <div className='info-icon'>
                    <InformationIcon />
                  </div>
                }
                description={tooltipText}
                parentCompoent='info-icon'
              />
            </span>
          ) : null}
        </div>
        {isLimited ? (
          <label className='limit'>
            <span>Remaining:</span>
            {` ${limit - (value ? value.length : 0)}`}
          </label>
        ) : null}
        {/* <TextArea name={inputName} placeholder={placeholder} value={value} onChange={onChange.bind(this, handleChange)} autosize={{ minRows: 2, maxRows: 6 }} maxLength={limit} onClick={onFocus} readOnly={!isEditable} /> */}
        <p className='json-error'>{jsonErrorMessage ? 'Please Enter Valid JSON' : ''}</p>
      </div>
      <div
        className='json-editor-container'
        onClick={() => {
          if (showContentInModal) {
            // on clicking cancel on modal, editor should reset back, so saving initial state in local variable
            if (jsonEditorInitialValues.current.isInitialJsonEditorChange) {
              jsonEditorInitialValues.current.isInitialJsonEditorChange = false
              jsonEditorInitialValues.current.isInitialJsonEditorValue = value
            }
            handleJsonEditorOpenClose(true, currentId)
            // if content is empty set text view by default
            setDefaultMode(jsonEditorValueDetails, currentId, DEFAULT_MODE)
            isFormDirty.current = getFormDirtyValue(isConfigObjectSaveDisable, useFor, isEnable)
          }
        }}
      >
        {/* mode will always tree mode in default view */}
        {getJsonEditorComponent(true, DEFAULT_MODE)}
      </div>
      <Modal
        title={`Edit - ${title}`}
        visible={isJsonEditorModalOpen}
        onOk={() => {
          jsonEditorInitialValues.current.isInitialJsonEditorChange = true
          jsonEditorInitialValues.current.isInitialJsonEditorValue = null
          handleJsonEditorOpenClose(false, currentId)
          setDefaultMode(jsonEditorValueDetails, currentId, DEFAULT_MODE)
        }}
        onCancel={() => {
          // when canceled editor should reset back to previous state
          if (!isEqual(jsonEditorInitialValues.current.isInitialJsonEditorValue, value)) {
            let saveButtonFlag = true
            if (useFor === JASON_EDITOR_USED_FOR_TYPES.JSON_EDITOR_FOR_PAGES || useFor === JASON_EDITOR_USED_FOR_TYPES.JSON_EDITOR_FOR_LIST_CONFIG_TYPE) {
              // false = button enable ( has change ), true = button disable ( no change )
              if (isFormDirty.current) {
                saveButtonFlag = false
              } else {
                saveButtonFlag = true
              }
              console.log('useFor', useFor)
            } else if (useFor === JASON_EDITOR_USED_FOR_TYPES.JSON_EDITOR_FOR_SETTING_WIDGET) {
              // false = button enable ( has change ), true = button disable ( no change )
              if (isFormDirty.current) {
                saveButtonFlag = true
              } else {
                saveButtonFlag = false
              }
            }
            handleChange({ text: jsonEditorInitialValues.current.isInitialJsonEditorValue }, saveButtonFlag)
          }
          isFormDirty.current = null
          handleJsonEditorOpenClose(false, currentId)
          setDefaultMode(jsonEditorValueDetails, currentId, DEFAULT_MODE)
        }}
        className='general-modal json-editor-modal'
        width={'calc(100vw - 100px)'}
        destroyOnClose
        style={{
          top: '10px',
          bottom: '10px',
          left: '10px',
          right: '10px'
        }}
      >
        <div className='json-editor-modal-container'>
          <div className='json-field-header'>
            <div className='text-wrapper'>
              <p>{title} {isRequired && <span className='mandatory'>*</span>}</p>
            </div>
            <div className='icon-wrapper'>
              <PopoverConfirm
                warningMessage='Are you sure you want to clear the field ?'
                confirm={() => handleChange('')}
              />
              <Icon type='copy' onClick={() => copyOnClick(jsonEditorValueDetails, 'JSON')} />
            </div>
          </div>
          {getJsonEditorComponent(!isEditable, mode)}
        </div>
      </Modal>
      <AddImageModal
        // onChangeModal={(a, b, c, d, f) => console.log('onChangeModal', { a, b, c, d, f })}
        // type={(a, b, c, d, f) => console.log('type', { a, b, c, d, f })}
        isMultiSelect={false}
        isVisible={isImageModalOpen}
        handleCancel={() => setIsImageModalOpen(false)}
        isUpdateDisabled={false}
        handleSubmit={selectedImage => {
          // integrate selected image to state
          const fileName = selectedImage?.[0]?.fileName || ''
          const contentCopy = value ? JSON.parse(value) : null
          const valuePath = imagePathDetails.path.join('.')
          set(contentCopy, valuePath, fileName)
          if (!isEmpty(contentCopy)) {
            const content = { text: JSON.stringify(contentCopy, null, JSON_EDITOR_INDENTATION) }
            handleChange(content)
            setIsImageModalOpen(false)
          }
        }}
        isSubmitButtonDisabled={false}
        isCancelButtonDisabled={false}
        currentSelection={[]}
        mediaType='IMAGE'
        project={project}
      />
    </div>
  )
}

TextAreaInputApp.propTypes = {
  /** Change action of TextAreaInputApp. */
  handleChange: PropTypes.func,
  /** display value of TextAreaInputApp. */
  value: PropTypes.string,
  /** placeholder of TextAreaInputApp. */
  placeholder: PropTypes.string.isRequired,
  /** title of TextAreaInputApp. */
  title: PropTypes.string.isRequired,
  /** input name of TextAreaInputApp. */
  inputName: PropTypes.string.isRequired,
  /** editable status of TextAreaInputApp. */
  isEditable: PropTypes.bool,
  /** string limited status of TextAreaInputApp. */
  isLimited: PropTypes.bool,
  /** string limit of TextAreaInputApp. */
  limit: PropTypes.number
}

TextAreaInputApp.defaultProps = {
  isEditable: true
}

export default TextAreaInputApp
